import moment from 'moment';
import { LEAD_SOURCES } from '../../../common/constants/leadSources';

export const checkValuationExpired = ({ divisionId, lastValuationDate}) => {
    const days = divisionId.toString() === LEAD_SOURCES.WBABCOM ? 5 : 7; 
        
    return { hasExpired: new moment().diff(lastValuationDate, 'days') > days, days };
}


// WEBPACK FOOTER //
// ./src/modules/Leads/utils/checkValuationExpired.js